export enum CertificatePurpose {
  Unknown = 0,
  SSL = 1,
  LDAP = 2,
  IEEE8021X_Device = 3,
  IEEE8021X_Server = 4
}

export const infrastructureCertificatePurposeTranslationKey = (enumValue: CertificatePurpose | undefined): string => {
  switch (enumValue) {
    case CertificatePurpose.SSL:
      return 'Infrastructure_CertificatePurpose_SSL'
    case CertificatePurpose.LDAP:
      return 'Infrastructure_CertificatePurpose_LDAP'
    case CertificatePurpose.IEEE8021X_Device:
      return 'Infrastructure_CertificatePurpose_IEEE8021X_Device'
    case CertificatePurpose.IEEE8021X_Server:
      return 'Infrastructure_CertificatePurpose_IEEE8021X_Server'
    default:
      return 'Infrastructure_CertificatePurpose_Unknown'
  }
}